// 공용 함수
export function isNotNull(value) {
    return !(value === undefined || value === null);
}

export function isNotNullAll(...values) {
    if (values.length === 0) {
        return false; // 빈 배열인 경우 false 반환
    }
    return values.every(value => value !== null && value !== undefined);
}

export default new class Utils {
    constructor() {
        this.isNotNull = isNotNull;
        this.isNotNullAll = isNotNullAll;
    }
}